import request from '@/http'
// let url = process.env.VUE_APP_APIMATERIALS
export const apiPopularityTeam = {
  getAreaById1: (id) => request.get(`/sysArea/cityAreaByParentNo?parentNo=${id}`), // 获取市区 含市缩写
  getTeamPopular: (data) => request.post(`/teamInfo/teamPopular`, data) // 获取人气工队列表
}
